import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import '../styles/ShoesPage.css';
import menShoesBg from '../assets/men-shoes-bg.jpg';
import womenShoesBg from '../assets/women-shoes-bg.jpg';

const ShoesPage = () => {
    const navigate = useNavigate();

    const handleGenderClick = (gender) => {
        navigate(`/shop?type=shoe&gender=${gender}`);
    };

    useEffect(() => {
    }, []);

    return (
        <div className="shoes-page">
            <Row className="g-0 flex-nowrap">
                <Col xs={6} className="gender-section" style={{backgroundImage: `url(${menShoesBg})`}} onClick={() => handleGenderClick('мужской')}>
                    <div className="gender-content"><h2>Мужская обувь</h2></div>
                </Col>
                <Col xs={6} className="gender-section" style={{backgroundImage: `url(${womenShoesBg})`}} onClick={() => handleGenderClick('женский')}>
                    <div className="gender-content"><h2>Женская обувь</h2></div>
                </Col>
            </Row>
        </div>
    );
};

export default ShoesPage; 